import React, { useEffect, useState } from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { decryptData } from "../../utils/encrypt";
import {
  SALES_ORDER_CUSTOMER_LIST,
  MATERIAL_LIST_ENDPOINT,
  GET_LOADING_POINTS_ENDPOINT,
  DISPATCH_PENDING_FILTERS_API,PACKING_TYPE_LIST_ENDPOINT 
} from "../../config/api";
import DispatchPendingTable from "./DispatchPendingTable";

function DispatchPendingReport() {


  const [lookups, setLookups] = useState({
    customers: [],
    materials: [],
    packingTypes: ["25 Kgs Bags", "50 Kgs Bag", "Loose Bulker"],
    loadingPoints: [],
  });

   const [packingOptions, setPackingOptions] = useState([]); // <-- add
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);
  const [orgId, setOrgId] = useState(null);


  const toYMD = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

const computeDefaultDates = () => {
  const now = new Date();
  const from = new Date(now); from.setDate(from.getDate() - 14); // today - 2w
  const to = new Date(now);   to.setDate(to.getDate() + 14);     // today + 2w
  return { from: toYMD(from), to: toYMD(to) };
};

const [filters, setFilters] = useState(() => {
  const { from, to } = computeDefaultDates();
  return {
    customer_id: "",
    material_id: "",
    packing_type: "",
    loading_point_id: "",
    delivery_from: from,  // default today - 2w
    delivery_to: to,      // default today + 2w
    invoiced_status: "",
    vehicle_status: "",
    logistic_status: "",
  };
});


   useEffect(() => {
    (async () => {
      try {
        const res = await fetch(PACKING_TYPE_LIST_ENDPOINT);
        const data = await res.json();
        // expect [{id, name}]
        setPackingOptions(Array.isArray(data) ? data : []);
      } catch (e) {
        console.warn('Packing types fetch failed:', e);
        setPackingOptions([]);
      }
    })();
  }, []);
  // Load user/org
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("suyog_user");
      if (storedUser) {
        const u = decryptData(storedUser);
        setUserId(u?.user_id || null);
      }
    } catch (e) {
      console.error("Token decrypt failed:", e);
    }
    const storedOrg = localStorage.getItem("suyog_selected_org");
    if (storedOrg) {
      try {
        const parsedOrg = JSON.parse(storedOrg);
        setOrgId(parsedOrg?.value || null);
      } catch (e) {
        console.error("suyog_selected_org parse error:", e);
      }
    }
  }, []);

  // Load dropdowns
  useEffect(() => {
    if (!userId || !orgId) return;
    const loadDropdowns = async () => {
      try {
        const cRes = await fetch(SALES_ORDER_CUSTOMER_LIST, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: userId }),
        });
        const cJson = await cRes.json();
        const customers = Array.isArray(cJson) ? cJson : (cJson?.data || []);
        setLookups((prev) => ({ ...prev, customers }));

        const mRes = await fetch(MATERIAL_LIST_ENDPOINT);
        const mJson = await mRes.json();
        const materials = Array.isArray(mJson) ? mJson : (mJson?.data || []);
        setLookups((prev) => ({ ...prev, materials }));

        const lpRes = await fetch(GET_LOADING_POINTS_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ org_id: orgId }),
        });
        const lpJson = await lpRes.json();
        const loadingPoints = lpJson?.success && Array.isArray(lpJson.records) ? lpJson.records : [];
        setLookups((prev) => ({ ...prev, loadingPoints }));
      } catch (e) {
        console.error("Dropdowns load error:", e);
      }
    };
    loadDropdowns();
    fetchReport(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, orgId]);

  // Fetch report
  const fetchReport = async (withFilters = true) => {
    if (!userId || !orgId) return;
    setLoading(true);
    try {
      const res = await fetch(DISPATCH_PENDING_FILTERS_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: userId,
          org_id: orgId,
          include_vehicle_details: true,
          ...(withFilters ? filters : {}),
        }),
      });
      const data = await res.json();
      if (data?.success) setRows(data.rows || []);
      else setRows([]);
    } catch (err) {
      console.error("Report fetch error:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((f) => ({ ...f, [name]: value }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchReport(true);
  };

const handleReset = () => {
  const { from, to } = computeDefaultDates();
  setFilters((f) => ({
    ...f,
    customer_id: "",
    material_id: "",
    packing_type: "",
    loading_point_id: "",
    delivery_from: from,
    delivery_to: to,
    invoiced_status: "",
    vehicle_status: "",
    logistic_status: "",
  }));
  fetchReport(true); // apply the new defaults
};

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h4>🚛 Dispatch Pending Report</h4>

        {/* Filters */}
        <form className="row g-3 mt-2" onSubmit={handleSearch}>
          <div className="col-md-3">
            <label className="form-label">Customer</label>
            <select className="form-select" name="customer_id" value={filters.customer_id} onChange={handleChange}>
              <option value="">-- All Customers --</option>
              {lookups.customers.map((c) => (
                <option key={c.id} value={c.id}>{c.account_name}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">Material</label>
            <select className="form-select" name="material_id" value={filters.material_id} onChange={handleChange}>
              <option value="">-- All Materials --</option>
              {lookups.materials.map((m) => (
                <option key={m.id} value={m.id}>{m.material_name}</option>
              ))}
            </select>
          </div>

        <div className="col-md-3">
  <label className="form-label">Packing Type</label>
  <select
    className="form-select"
    name="packing_type"
    value={filters.packing_type}             // ✅ string in state
    onChange={(e) => setFilters(f => ({      // ✅ keep string
      ...f,
      packing_type: e.target.value
    }))}
  >
    <option value="" disabled={!packingOptions.length}>
      {packingOptions.length ? '-- All Packing --' : 'Loading...'}
    </option>

    {/* Prefer dynamic options from API */}
    {packingOptions.map(p => {
      const label = p.name ?? p.packing_type; // handle either field
      return (
        <option key={p.id ?? label} value={label}>
          {label}
        </option>
      );
    })}

    {/* Fallback to static list if API empty */}
    {packingOptions.length === 0 &&
      lookups.packingTypes.map(txt => (
        <option key={txt} value={txt}>{txt}</option>
      ))
    }
  </select>
</div>



          <div className="col-md-3">
            <label className="form-label">Loading Point</label>
            <select className="form-select" name="loading_point_id" value={filters.loading_point_id} onChange={handleChange}>
              <option value="">-- All Loading Points --</option>
              {lookups.loadingPoints.map((lp) => (
                <option key={lp.id} value={lp.id}>{lp.name}</option>
              ))}
            </select>
          </div>

        <div className="col-md-3">
  <label className="form-label">Delivery From</label>
  <input
    type="date"
    className="form-control"
    name="delivery_from"
    value={filters.delivery_from}
    onChange={handleChange}
  />
</div>
<div className="col-md-3">
  <label className="form-label">Delivery To</label>
  <input
    type="date"
    className="form-control"
    name="delivery_to"
    value={filters.delivery_to}
    onChange={handleChange}
  />
</div>


          <div className="col-md-2">
            <label className="form-label">Invoiced</label>
            <select className="form-select" name="invoiced_status" value={filters.invoiced_status} onChange={handleChange}>
              <option value="">All</option>
              <option>Pending</option>
              <option>Done</option>
            </select>
          </div>

          <div hidden className="col-md-2">
            <label className="form-label">Vehicle Status</label>
            <select className="form-select" name="vehicle_status" value={filters.vehicle_status} onChange={handleChange}>
              <option value="">All</option>
              <option>Pending</option>
              <option>Done</option>
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">Logistic Planned</label>
            <select className="form-select" name="logistic_status" value={filters.logistic_status} onChange={handleChange}>
              <option value="">All</option>
              <option>Pending</option>
              <option>Done</option>
            </select>
          </div>

          <div className="col-12 d-flex gap-2">
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? "Loading..." : "Search"}
            </button>
            <button className="btn btn-secondary" type="button" onClick={handleReset}>
              Reset
            </button>
          </div>
        </form>

        {/* Table component */}
        <DispatchPendingTable rows={rows} />
      </div>
      <Footer />
    </>
  );
}

export default DispatchPendingReport;
